// extracted by mini-css-extract-plugin
module.exports = {"trait-box":"trait-box_1M2Q","items":"items_1rbS","item":"item_unWf","img":"img_BJWJ"};